import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles(() => ({
  text: {
    width: '100%',
    fontFamily: 'Lato',
    fontWeight: ({ fontWeight }) => fontWeight || '500',
    fontSize: ({ fontSize }) => fontSize || '12px',
    lineHeight: ({ lineHeight }) => lineHeight || '16.8px',
    color: ({ required, color }) => (required ? 'rgba(0, 0, 0, 0.4)' : color || 'rgba(102, 112, 133, 1)'),
    textAlign: ({ align }) => align || 'start',
  },
  asterisk: {
    color: '#F50000',
  },
}));

const CustomPopupText = ({
  id,
  required,
  text,
  fontSize,
  fontWeight,
  lineHeight,
  color,
  align,
  count = false,
  totalWords,
  word,
}) => {
  const classes = useStyles({ required, fontSize, fontWeight, lineHeight, color, align });

  return (
    <Grid container direction="row" justifyContent="space-between">
      <Grid item>
        <Typography id={id} className={classes.text}>
          {text}
          {required && <span className={classes.asterisk}> *</span>}
        </Typography>
      </Grid>
      {count && (
        <Grid item>
          <Typography id={id} className={classes.text}>
            {`${word?.length}/${totalWords}`}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default React.memo(CustomPopupText);
